import { QueryRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkSheetTransition } from 'uitk-react-sheet';
export var PopupMessage = function (props) {
  var _a;
  var dialogId = props.dialogId,
    isNestedPopup = props.isNestedPopup,
    messages = props.messages,
    linkRef = props.linkRef,
    analytics = props.analytics,
    dismissAction = props.dismissAction,
    disclaimer = props.disclaimer;
  var location = useLocation();
  var footer = (_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.dialog) === null || _a === void 0 ? void 0 : _a.footer;
  var buttonTypes = footer === null || footer === void 0 ? void 0 : footer.buttons.map(function (button) {
    return button;
  });
  var history = useHistory();
  if (!location || !messages) {
    return null;
  }
  var onDismiss = function () {
    if (analytics && (dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.referrerId)) {
      analytics.trackEvent(dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.referrerId, dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.linkName, analytics.omnitureData, null, true);
    }
    history.goBack();
    linkRef.current.focus();
  };
  var linkDialog = function () {
    if (dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.dialogActionsLinkTagUrl) {
      analytics === null || analytics === void 0 ? void 0 : analytics.trackEvent(dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.dialogActionsRfrrId, dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.dialogActionsLinkName, analytics.omnitureData, null, true);
      var target = (dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.dialogActionsOpensInNewTab) ? '_blank' : '_self';
      window.open(dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.dialogActionsLinkTagUrl, target);
    }
  };
  var buttons = buttonTypes === null || buttonTypes === void 0 ? void 0 : buttonTypes.map(function (button) {
    var _a;
    return {
      text: (_a = button.primary) !== null && _a !== void 0 ? _a : '',
      type: 'tertiary',
      onClick: (dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.dialogActionsAccessibilityText) === button.primary ? linkDialog : onDismiss
    };
  });
  var content = function () {
    var _a, _b;
    if (messages) {
      return React.createElement(UitkDialogContent, {
        key: "".concat(dialogId, "-dialog")
      }, messages.map(function (message, count) {
        return React.createElement("div", {
          key: count,
          className: "uitk-type-300"
        }, message);
      }), (dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.text) ? React.createElement(UitkDialogFooter, {
        key: "".concat(dialogId, "-footer"),
        buttonOne: {
          onClick: function () {
            return onDismiss();
          },
          text: dismissAction === null || dismissAction === void 0 ? void 0 : dismissAction.text,
          type: 'tertiary'
        }
      }) : React.createElement(UitkDialogFooter, {
        key: "".concat(dialogId, "-footer"),
        buttonOne: (_a = buttons[0]) !== null && _a !== void 0 ? _a : undefined,
        buttonTwo: (_b = buttons[1]) !== null && _b !== void 0 ? _b : undefined
      }));
    }
    return React.createElement(React.Fragment, null);
  };
  return React.createElement(QueryRoute, {
    query: isNestedPopup ? {
      pwaDialogNested: dialogId
    } : {
      pwaDialog: dialogId
    }
  }, React.createElement(UitkSheetTransition, {
    isVisible: true
  }, React.createElement(Layer, {
    id: "".concat(dialogId, "-layer"),
    onDismiss: onDismiss
  }, React.createElement(UitkDialog, {
    dialogShow: true,
    returnFocusOnClose: true
  }, content()))));
};